import { http } from '@/services/api/client';
import type {
  CreateTaskBatchPayload,
  CreateTaskBatchResult,
  QueryTasksParams,
  TaskDetail,
  TaskPageResult,
  TaskGroupPageResult,
  TaskWeeklyReportPage,
} from '@/types/task';

export async function fetchTasks(params: QueryTasksParams): Promise<TaskPageResult> {
  return http.get('/tasks', { params }) as Promise<TaskPageResult>;
}

export async function fetchTaskGroups(params: QueryTasksParams): Promise<TaskGroupPageResult> {
  return http.get('/tasks/groups', { params }) as Promise<TaskGroupPageResult>;
}

export async function fetchProjectTasks(
  projectId: string,
  params: QueryTasksParams,
): Promise<TaskPageResult> {
  return http.get(`/projects/${projectId}/tasks`, { params }) as Promise<TaskPageResult>;
}

export async function fetchTask(id: string): Promise<TaskDetail> {
  return http.get(`/tasks/${id}`) as Promise<TaskDetail>;
}

export async function fetchTaskWeeklyReports(
  id: string,
  params: { page: number; pageSize: number },
): Promise<TaskWeeklyReportPage> {
  return http.get(`/tasks/${id}/weekly-reports`, { params }) as Promise<TaskWeeklyReportPage>;
}

export async function deleteTask(id: string): Promise<{ success: true }> {
  return http.delete(`/tasks/${id}`) as Promise<{ success: true }>;
}

export async function startTask(id: string): Promise<TaskDetail> {
  return http.post(`/tasks/${id}/start`) as Promise<TaskDetail>;
}

export async function completeTask(
  id: string,
  payload?: { completionNote?: string },
): Promise<TaskDetail> {
  return http.post(`/tasks/${id}/complete`, payload ?? {}) as Promise<TaskDetail>;
}

export async function createTaskBatch(
  payload: CreateTaskBatchPayload,
): Promise<CreateTaskBatchResult> {
  return http.post('/tasks/batch', payload) as Promise<CreateTaskBatchResult>;
}

export async function updateTaskProgress(
  id: string,
  progressContent: string,
): Promise<TaskDetail> {
  return http.post(`/tasks/${id}/progress`, { progressContent }) as Promise<TaskDetail>;
}

export async function verifyTask(
  id: string,
  payload: { result: 'COMPLETED' | 'INCOMPLETE'; note?: string },
): Promise<TaskDetail> {
  return http.post(`/tasks/${id}/verify`, payload) as Promise<TaskDetail>;
}
